import React from "react";

export default function Glas() {
  /*https://codepen.io/clemishow/pen/ZYPPeE/*/
  return (
    <div id={"backdrop"}>
      <div id={"glass"}>
        <div id={"beer"} />
      </div>
      <div id={"poignet"} />
      <div id={"mousse_1"} />
      <div id={"mousse_2"} />
      <div id={"mousse_3"} />
      <div id={"mousse_4"} />
      <div id={"mousse_5"} />
      <div id={"mousse_volante"} />
      <div id={"mousse_interieur"} />
      <div id={"mousse_interieur_2"} />
      <div id={"mousse_interieur_3"} />
      <div id={"mousse_interieur_4"} />
    </div>
  );
}
